"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateCorrelationId = generateCorrelationId;
const nanoid_1 = require("nanoid");
const MaxRandomPartLength = 7;
const AlphanumericLowercase = "abcdefghijklmnopqrstuvwxyz0123456789";
const nanoid = (0, nanoid_1.customAlphabet)(AlphanumericLowercase, MaxRandomPartLength);
function generateCorrelationId(prefix) {
    return `${prefix}${nanoid()}`;
}
//# sourceMappingURL=generate-correlation-id.js.map